import { SHOPIFY_AGZ_WELCOME_KIT_VARIANT_ID } from '@portal/config/base';
import { StoreCode } from '@portal/schema/storeCode';
import { includesVariant } from './includesVariant';

export const isAgzFrotherWelcomeKit = (variantId: string, store: StoreCode) => {
  return includesVariant(variantId, SHOPIFY_AGZ_WELCOME_KIT_VARIANT_ID[store]);
};
